define([
	"dojo/_base/declare",
	"csi/property/Widget",
	"./ProductType"
], function(declare, Widget, ProductType) {

	return declare(Widget, {
		getCustomViewNodeContextsStore: function() {
			// summary: return store of product types
			return ProductType.store(this.productType);
		},

		setViewNode: function(/*Node*/node, /*Boolean*/bSaveSelections) {
			// summary: prefNodeContext needs to vary based on product type
			this.prefNodeContext = ProductType.name(node);
			this.inherited(arguments);
		}
	});
});